import { configureStore } from "@reduxjs/toolkit";
import courseSlice from "./AddCourseSlice";
export default configureStore({
    reducer:{
        course:courseSlice,
    }
})